import { enUS } from './en_US';
import { thTH } from './th_TH';

export const Languages = [enUS, thTH];
